import React, { useEffect } from 'react';
import { RiCheckLine, RiLoader4Line } from 'react-icons/ri';

export const TUTORIAL_CSS = `
  @keyframes sdemo-slide {
    from { opacity: 0; transform: translateY(10px); }
    to   { opacity: 1; transform: translateY(0); }
  }
  @keyframes sdemo-dot {
    0%, 100% { opacity: 0.25; transform: scale(0.75); }
    50%       { opacity: 1;    transform: scale(1); }
  }
  @keyframes sdemo-spin {
    from { transform: rotate(0deg); }
    to   { transform: rotate(360deg); }
  }
  .sdemo-enter { animation: sdemo-slide 0.4s ease-out both; }
  .sdemo-dot {
    display: inline-block; width: 6px; height: 6px;
    border-radius: 50%; margin: 0 2px;
    animation: sdemo-dot 1.1s ease-in-out infinite;
  }
  .sdemo-dot:nth-child(2) { animation-delay: 0.18s; }
  .sdemo-dot:nth-child(3) { animation-delay: 0.36s; }
  .sdemo-spin { animation: sdemo-spin 1s linear infinite; }
`;

export function useInjectCSS() {
  useEffect(() => {
    const id = 'stackform-tutorial-css';
    if (!document.getElementById(id)) {
      const el = document.createElement('style');
      el.id = id;
      el.textContent = TUTORIAL_CSS;
      document.head.appendChild(el);
    }
  }, []);
}

export const ThinkingDots = () => (
  <span style={{ display: 'inline-flex', alignItems: 'center', height: '1em' }}>
    <span className="sdemo-dot" style={{ backgroundColor: 'currentColor' }} />
    <span className="sdemo-dot" style={{ backgroundColor: 'currentColor' }} />
    <span className="sdemo-dot" style={{ backgroundColor: 'currentColor' }} />
  </span>
);

export const AgentChip = ({ name, color, badge, badgeColor }) => (
  <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '6px' }}>
    <span style={{
      display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
      width: 28, height: 28, borderRadius: '50%',
      backgroundColor: `${color}22`, color, fontWeight: 700, fontSize: '0.75rem',
    }}>
      {name[0]}
    </span>
    <span style={{ fontWeight: 600, fontSize: '0.85rem', color }}>{name}</span>
    {badge && (
      <span style={{
        fontSize: '0.7rem', fontWeight: 700, padding: '1px 7px',
        borderRadius: '999px', letterSpacing: '0.03em',
        backgroundColor: `${badgeColor || color}22`, color: badgeColor || color,
      }}>
        {badge}
      </span>
    )}
  </div>
);

export const Bubble = ({ children, align = 'left', color, className = 'sdemo-enter' }) => (
  <div
    className={className}
    style={{
      alignSelf: align === 'right' ? 'flex-end' : 'flex-start',
      maxWidth: '88%',
      padding: '0.65rem 0.9rem',
      borderRadius: align === 'right' ? '14px 14px 4px 14px' : '4px 14px 14px 14px',
      backgroundColor: align === 'right'
        ? 'var(--primary-color, #636cff)'
        : 'var(--bg-secondary, #f5f5f5)',
      border: align === 'right' ? 'none' : `1px solid ${color || 'var(--border-color, #ddd)'}`,
      color: align === 'right' ? '#fff' : 'inherit',
      fontSize: '0.88rem',
      lineHeight: 1.55,
    }}
  >
    {children}
  </div>
);

export const SectionLabel = ({ children }) => (
  <div style={{
    fontSize: '0.72rem', fontWeight: 700, textTransform: 'uppercase',
    letterSpacing: '0.06em', color: 'var(--text-secondary, #888)',
    marginBottom: '0.75rem', marginTop: '1.25rem',
  }}>
    {children}
  </div>
);

export const ExplainerRow = ({ Icon, iconColor, label, description }) => (
  <div style={{ display: 'flex', gap: '0.75rem', alignItems: 'flex-start', marginBottom: '0.9rem' }}>
    <span style={{
      flexShrink: 0,
      display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
      width: 32, height: 32, borderRadius: '8px',
      backgroundColor: `${iconColor}18`, color: iconColor,
      marginTop: '1px',
    }}>
      <Icon size={17} />
    </span>
    <div>
      <div style={{ fontWeight: 600, fontSize: '0.88rem', marginBottom: '2px' }}>{label}</div>
      <div style={{ fontSize: '0.84rem', color: 'var(--text-color)', lineHeight: 1.5 }}>
        {description}
      </div>
    </div>
  </div>
);

export const AgentStatusRow = ({ name, done }) => (
  <div className="sdemo-enter" style={{
    display: 'flex', alignItems: 'center', gap: '8px',
    fontSize: '0.82rem', color: done ? '#28a745' : 'var(--text-secondary, #888)',
    padding: '4px 0',
  }}>
    {done
      ? <RiCheckLine size={15} style={{ flexShrink: 0 }} />
      : <RiLoader4Line size={15} className="sdemo-spin" style={{ flexShrink: 0 }} />
    }
    <span><strong>{name}</strong> {done ? 'research complete' : 'searching…'}</span>
  </div>
);
